var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isMobile?'deletedM':'deleted'},[_vm._v("\n  "+_vm._s(_vm.pageData)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }